import {
  DATE_OPERATORS,
  ENUM_OPERATORS,
  NUMBER_OPERATORS,
  QueryFieldDefinition,
} from './types'

/** Queryable fields for the CONTACT module. */
export const CONTACT_QUERY_FIELDS: QueryFieldDefinition[] = [
  {
    key: 'text',
    label: 'Text',
    type: 'text',
    description: 'Searches name, email and company',
    example: 'text ~ "acme"',
    operators: ['~', '!~'],
  },
  {
    key: 'name',
    label: 'Name',
    type: 'text',
    description: 'Matches first name, last name or full name',
    example: 'name ~ "smith"',
    operators: ['=', '!=', '~', '!~'],
    sortable: true,
  },
  {
    key: 'email',
    label: 'Email',
    type: 'text',
    example: 'email ~ "@acme.com"',
    operators: [
      '=',
      '!=',
      '~',
      '!~',
      'IN',
      'NOT IN',
      'IS EMPTY',
      'IS NOT EMPTY',
    ],
    sortable: true,
  },
  {
    key: 'phone',
    label: 'Phone',
    type: 'text',
    operators: ['=', '!=', '~', 'IS EMPTY', 'IS NOT EMPTY'],
  },
  {
    key: 'company',
    aliases: ['companyName'],
    label: 'Company',
    type: 'text',
    description: 'Free-text company name',
    example: 'company ~ "labs"',
    operators: ['=', '!=', '~', '!~', 'IS EMPTY', 'IS NOT EMPTY'],
  },
  {
    key: 'title',
    aliases: ['jobTitle'],
    label: 'Job title',
    type: 'text',
    example: 'title ~ "engineer"',
    operators: ['=', '!=', '~', '!~', 'IS EMPTY', 'IS NOT EMPTY'],
  },
  {
    key: 'department',
    label: 'Department',
    type: 'text',
    operators: ['=', '!=', '~', 'IS EMPTY', 'IS NOT EMPTY'],
  },
  {
    key: 'lifecycleStage',
    aliases: ['stage', 'lifecycle'],
    label: 'Lifecycle stage',
    type: 'enum',
    description: 'Matches lifecycle stage name or id (e.g. contact, customer)',
    example: 'lifecycleStage = customer',
    operators: ENUM_OPERATORS,
    optionSource: 'statuses',
    sortable: true,
  },
  {
    key: 'vendorStage',
    label: 'Vendor stage',
    type: 'enum',
    example: 'vendorStage = vendor',
    operators: ENUM_OPERATORS,
  },
  {
    key: 'entity',
    aliases: ['client'],
    label: 'Entity',
    type: 'reference',
    description: 'Matches the linked entity by name',
    example: 'entity = "Acme Corp"',
    operators: ENUM_OPERATORS,
    optionSource: 'entities',
  },
  {
    key: 'assignee',
    aliases: ['owner', 'assignedTo'],
    label: 'Assigned to',
    type: 'user',
    example: 'assignee = currentUser()',
    operators: ['=', '!=', 'IN', 'NOT IN', 'IS EMPTY', 'IS NOT EMPTY'],
    optionSource: 'members',
    supportsCurrentUser: true,
  },
  {
    key: 'source',
    label: 'Source',
    type: 'text',
    example: 'source = referral',
    operators: ['=', '!=', '~', 'IN', 'NOT IN', 'IS EMPTY', 'IS NOT EMPTY'],
  },
  {
    key: 'score',
    label: 'Score',
    type: 'number',
    example: 'score >= 80',
    operators: NUMBER_OPERATORS,
    sortable: true,
  },
  {
    key: 'city',
    label: 'City',
    type: 'text',
    operators: ['=', '!=', '~', 'IS EMPTY', 'IS NOT EMPTY'],
  },
  {
    key: 'country',
    label: 'Country',
    type: 'text',
    operators: ['=', '!=', '~', 'IN', 'NOT IN', 'IS EMPTY', 'IS NOT EMPTY'],
  },
  {
    key: 'created',
    aliases: ['createdAt'],
    label: 'Created date',
    type: 'date',
    example: 'created >= -30d',
    operators: DATE_OPERATORS,
    sortable: true,
  },
  {
    key: 'updated',
    aliases: ['updatedAt'],
    label: 'Updated date',
    type: 'date',
    operators: DATE_OPERATORS,
    sortable: true,
  },
]
